import React from 'react';

const MenuItemIcon = ({ alt, selected, icon, activeIcon, ...props }: any) => (
  <img {...props} src={selected ? activeIcon : icon} alt={alt} className="max-w-none" />
);
export default MenuItemIcon;
